import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";
import { H5 } from "../Texts";

const DashedCardStyle = styled.div`
  background: ${(props) => props.bg || "#ffffff"};
  color: ${(props) => props.color || "#442ED0"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-family: ${(props) => props.fontFamily || "semi"}, sans-serif;
  height: ${(props) => props.h || "77px"};
  border: 1px dashed #442ed0;
  border-radius: 3px;

  &:focus {
    border-color: #442ecf50;
    outline-color: #442ecf50;
  }
`;

export const DashedCard = ({ title, width }) => (
  <DashedCardStyle
    width={width}
    className="bg-white p-5 flex items-center justify-center shadow hover:shadow-md duration-300 cursor-pointer"
  >
    <div>
      <Icon.Plus fill="#442ED0" color="#442ED0" size={20} className="mr-2" />
    </div>
    <div className="truncate">
      <H5
        color="#442ED0"
        fontSize="16px"
        smallSize="16px"
        className="mb-0 font-semibold truncate"
      >
        {title}
      </H5>
    </div>
  </DashedCardStyle>
);
